import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Text } from '@domain-group/suit-theme'

import { buildItemTitle, buildOptionsString } from '@functions/orderItem'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

interface OrderItemDetailsProps {
  orderItemPayload: UseOrderItemPayload,
}

const OrderItemDetails = (props: OrderItemDetailsProps) => {
  const {
    orderItemPayload: {
      callbacks: {
        editQuantityAndOptions,
      },
      canEditQuantityAndOptions,
      orderItem,
      orderItem: {
        options,
      },
    },
  } = props

  return (
    <Box alignItems="center" height={80} padding="large" style={{ boxShadow: '1px 1px 10px rgba(0, 0, 0, 0.05)' }}>
      <Box flexDirection="column" fontSize="small">
        <Text>{buildItemTitle({ orderableItem: orderItem, excludeOptionsString: true })}</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" lineHeight="1.3" marginTop="small">
          {/*
           // @ts-expect-error TS2345 */}
          {buildOptionsString(options)}
        </Text>
      </Box>

      {canEditQuantityAndOptions && (
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPencil} />}
          marginLeft="auto"
          onClick={editQuantityAndOptions}
          size="small"
          // @ts-expect-error TS2322
          text="Edit Qty/Options"
          width="auto"
        >
          Edit Qty/Options
        </Button>
      )}
    </Box>
  )
}

export default OrderItemDetails
